import React, { Suspense } from 'react';
import { HistoryRouter as Router } from 'redux-first-history/rr6';
import { Provider } from 'react-redux';

// eslint-disable-next-line import/no-unresolved
import AppConfig from 'appconfig';
import Layout from '../components/core/Layout';

// Components
import TranslationsStore from '../containers/TranslationsStore';
import { store, history, sagaMiddleware } from '../createStore';
import CredentialStore from '../services/credentials';
import LocalStorageStore from '../services/localStorageStore.js';
import { watchRefreshTokensRequests } from '../services/checkHUBTokens';
import { HUBAdmin } from '../sagas';

import AppRoutes from './AppRoutes';

const credentialStore = new CredentialStore(new LocalStorageStore(AppConfig.activeEnvironment.hubEnvironment));
sagaMiddleware.run(HUBAdmin, credentialStore);
sagaMiddleware.run(watchRefreshTokensRequests, credentialStore);

function Root() {
    return (
        <TranslationsStore language="nl">
            <Provider store={store}>
                <Router history={history}>
                    <Suspense fallback={<Layout />}>
                        <AppRoutes></AppRoutes>
                    </Suspense>
                </Router>
            </Provider>
        </TranslationsStore>
    );
}

export default Root;
